import { database } from "../firebaseConfig";
import { ref, set } from "firebase/database";

export function syncCheckinData(userId, data) {
  // write checkin data
  set(ref(database, `users/${userId}/pendingCheckin`), data);
}
